import { canReachPromoterAccounts } from '@/utils/promoterAccounts';
import { BLOCKED_MESSAGE } from '@/utils/promoterAccess';

const VERSION_EPOCH_YEAR = 2021;

const SESSION = {
  active: {
    label: 'Conta ativa',
    tone: 'is-success',
    help: 'Você pode criar e editar propostas nesta conta.',
  },
  consult: {
    label: 'Somente consulta',
    tone: 'is-variant-info',
    help: 'Clientes e propostas disponíveis apenas para consulta.',
  },
  blocked: {
    label: 'Bloqueada',
    tone: 'is-variant-info',
    help: BLOCKED_MESSAGE,
  },
};

export function accountActions({
  canSwitchPromoter, isInternalUser, isCollector, rewardsDisabled,
}) {
  return [
    canSwitchPromoter && { id: 'accounts', label: 'Contas e acessos' },
    !isInternalUser && !isCollector && !rewardsDisabled
      && { id: 'benefits', label: 'Meus benefícios', route: 'livelo-statement' },
    { id: 'edit', label: 'Editar usuário', route: 'edit-user' },
    { id: 'terms', label: 'Termos e Políticas', route: 'terms' },
    !isCollector && { id: 'guidelines', label: 'Roteiros operacionais', route: 'guidelines' },
    { id: 'reload', label: 'Atualizar sistema' },
    { id: 'logout', label: 'Sair' },
  ].filter(Boolean);
}

export function accountButtonLabel(name) {
  const shown = String(name ?? '').trim();

  return shown ? `${shown}, menu da conta` : 'Menu da conta';
}

export function allowsPromoterSwitch({ user, isInternalUser, isPromoterActive }) {
  return !isInternalUser && canReachPromoterAccounts(user, isPromoterActive);
}

export function showsRewards({ user, isInternalUser, isCollector }) {
  return Boolean(user?.name) && !user?.rewards_disabled && !isInternalUser && !isCollector;
}

export function sessionState(isPromoterActive, isPromoterBlocked = false) {
  if (isPromoterBlocked && !isPromoterActive) return { ...SESSION.blocked };

  return { ...(isPromoterActive ? SESSION.active : SESSION.consult) };
}

export function appVersion(deployVersion) {
  if (!deployVersion) return '—';

  const date = new Date(Number(deployVersion) * 1000);

  if (Number.isNaN(date.getTime())) return String(deployVersion);

  const time = `${String(date.getHours()).padStart(2, '0')}${String(date.getMinutes()).padStart(2, '0')}`;

  return `${Math.abs(date.getFullYear() - VERSION_EPOCH_YEAR)}.${date.getMonth() + 1}.${date.getDate()}.${time}`;
}
